import { RouteObject } from "react-router";
import AdminGuard from "../guards/admin";
import AdminProfileView from "views/admin/profile/view";
import AdminLogoutView from "views/admin/logout/view";
import AdminLoginView from "views/admin/login/view";
import AdminListTemplatesView from "views/admin/settings/list-templates/view";
import AdminListTemplateView from "views/admin/settings/list-template/view";
import AdminSettingsView from "views/admin/settings/view";
import AdminListView from "views/admin/list/view";
import AdminSignicatErrorView from "views/admin/login/signicat/error";
import AdminSignicatAbortView from "views/admin/login/signicat/abort";
import AdminSignicatSuccessView from "views/admin/login/signicat/success";
import AdminListUserView from "views/admin/list/user/view";
import AdminRootView from "views/admin/root/view";
import AdminProvider from "providers/admin";
import AdminListProvider from "providers/admin-list";
import AdminListUserProvider from "providers/admin-list-user";
import AdminListTemplateProvider from "providers/admin-list-template";

export const adminRoutes: RouteObject[] = [
  {
    // start with nested routing
    path: "admin",
    children: [
      {
        path: "login",
        children: [
          { index: true, element: <AdminLoginView /> },
          {
            path: "signicat",
            children: [
              {
                path: "success",
                element: <AdminSignicatSuccessView />,
              },
              {
                path: "abort",
                element: <AdminSignicatAbortView />,
              },
              {
                path: "error",
                element: <AdminSignicatErrorView />,
              },
            ],
          },
        ],
      },
      { path: "logout", element: <AdminLogoutView /> },

      // guarded routes
      {
        element: <AdminGuard />,
        children: [
          {
            element: <AdminProvider />,
            children: [
              { path: "", element: <AdminRootView /> },
              {
                path: "profile",
                element: <AdminProfileView />,
              },
              {
                path: "settings",
                element: <AdminSettingsView />,
              },
              {
                path: "list-templates",
                element: <AdminListTemplatesView />,
              },
              {
                path: "list-template/:templateUuid",
                element: <AdminListTemplateProvider />,
                children: [{ index: true, element: <AdminListTemplateView /> }],
              },
              {
                path: "list/:listUuid",
                element: <AdminListProvider />,
                children: [
                  { index: true, element: <AdminListView /> },
                  {
                    path: "user/:userUuid",
                    element: <AdminListUserProvider />,
                    children: [{ index: true, element: <AdminListUserView /> }],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
